import React from "react";

const TFoot = ({
    page,
    limit,
    total_records,
    next,
    prev,
    getPageNumbers,
    setSearchParams,
    setLimit,
    setPage,
    total_pages
}) => {

    // const handleLimitChange = (e) => {
    //     const newLimit = Number(e.target.value);

    //     setLimit(newLimit);
    //     setPage(1);
    //     setSearchParams({ page: 1 });
    // };

    // const handlePageChange = (pageNumber) => {
    //     if (pageNumber < 1) return;

    //     setSearchParams({ page: pageNumber });

    //     const tableTop = document.getElementById("parts-table-top");
    //     tableTop?.scrollIntoView({
    //         behavior: "smooth",
    //         block: "start",
    //     });
    // };

    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);

        setLimit(newLimit);
        setPage(1);
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > total_pages) return;

        setPage(pageNumber); // ✅ ADD THIS

        const tableTop = document.getElementById("parts-table-top");
        if (tableTop) {
            tableTop.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };

    const startEntry = total_records === 0 ? 0 : (page - 1) * limit + 1;
    const endEntry = Math.min(page * limit, total_records);

    return (
        <tfoot>
            <tr>
                <td colSpan={11}>
                    <div className="d-flex justify-content-end align-items-center flex-wrap gap-2">

                        {/* Showing entries */}
                        <div className="show-entries">
                            Showing {startEntry} to {endEntry} of {total_records} entries
                        </div>

                        <div className="d-flex align-items-center gap-3">

                            {/* Pagination */}
                            <nav>
                                <ul className="custom-pagination mb-0">

                                    {/* First */}
                                    <li
                                        className={`page-btn ${!prev ? "disabled" : ""}`}
                                        onClick={() => prev && handlePageChange(1)}
                                    >
                                        &laquo;
                                    </li>

                                    {/* Previous */}
                                    <li
                                        className={`page-btn ${!prev ? "disabled" : ""}`}
                                        onClick={() => prev && handlePageChange(page - 1)}
                                    >
                                        &lt;
                                    </li>

                                    {/* Page numbers */}
                                    {getPageNumbers().map((p, index) =>
                                        p === "..." ? (
                                            <li
                                                key={`dots-${index}`}
                                                className="page-btn dots"
                                            >
                                                ...
                                            </li>
                                        ) : (
                                            <li
                                                key={p}
                                                className={`page-btn ${p === page ? "active" : ""}`}
                                                onClick={() => handlePageChange(p)}
                                            >
                                                {p}
                                            </li>
                                        )
                                    )}

                                    {/* Next */}
                                    <li
                                        className={`page-btn ${!next ? "disabled" : ""}`}
                                        onClick={() => next && handlePageChange(page + 1)}
                                    >
                                        &gt;
                                    </li>

                                </ul>
                            </nav>

                            {/* Limit dropdown */}
                            <div className="d-flex align-items-center ml-2">
                                <select
                                    className="form-control form-control-sm"
                                    value={limit}
                                    onChange={handleLimitChange}
                                >
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={150}>150</option>
                                    <option value={200}>200</option>
                                    <option value={250}>250</option>
                                </select>
                            </div>

                        </div>
                    </div>
                </td>
            </tr>
        </tfoot>
    );
};

export default TFoot;
